/* unplugin-vue-components disabled */import { render } from "./texts.vue?vue&type=template&id=3d38fb81"
import script from "./texts.vue?vue&type=script&lang=js"
export * from "./texts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__